<template>
  <div class="setPassword">
    <div class="loginLogoBox">
      <img src="./../../../assets/img/logo2.png" alt="" />
    </div>
    <div class="setPassFormBox">
      <div class="setPassForm">
        <p>密码重置</p>
        <el-input
          class="styleBox"
          v-model="username"
          placeholder="请输入用户名/证件号码"
        ></el-input>
        <el-row type="flex" class="styleBox" justify="space-between">
          <el-col>
            <el-input
              style="width:200px"
              v-model="code"
              placeholder="验证码"
            ></el-input>
          </el-col>
          <el-button :disabled="isSendSms" @click="getSendSma" type="primary">
            {{ this.isSendSms ? this.totalTime + "s后重新发送" : "发送验证码" }}
          </el-button>
        </el-row>
        <el-input
          class="styleBox"
          v-model="password"
          show-password
          placeholder="输入新密码"
        ></el-input>
        <el-input
          class="styleBox"
          show-password
          v-model="rePassword"
          placeholder="再次输入密码"
        ></el-input>
        <Debounce>
          <el-button style="width:100%;" @click="submit" type="primary"
            >完成</el-button
          >
        </Debounce>
        <div style="margin-top:10px">
          <span>已有账号?</span>
          <el-button @click="$router.push({ path: '/login' })" type="text"
            >立即登录</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      password: "",
      rePassword: "",
      totalTime: 60,
      isSendSms: false, //当前是否已经发送短信
      username: "",
      code: "",
      isSubmit: false, //是否为提交页面,默认为手机验证页面
      isTest: false, //是否验证了手机
    };
  },
  methods: {
    nextBut() {
      if (!this.isTest) {
        this.$message.warning({ message: "请先验证手机！" ,duration:1000});
        return;
      } else {
        isSubmit = true;
      }
    },
    submit() {
      let passTest = /^(\w){6,12}$/; //密码正则
      if (!passTest.test(this.password)) {
        this.$message.warning({ message: "请填写6-12位密码！" ,duration:1000});
        this.isModal = true;
        return;
      }
      if (this.password !== this.rePassword) {
        this.$message.warning({ message: "两次密码必须一致！",duration:1000 });
        return;
      }
      this.$axios
        .put("/login/update/password/", {
          userName: this.username,
          passWord: this.password,
          verificationCode: this.code,
        })
        .then((res) => {
          this.$message.success({
            message: "修改成功,正在前往登陆页面!",
            duration: 800,
            onClose: () => {
              this.$router.push({ path: "/login" });
            },
          });
        });
    },
    getSendSma() {
      if (this.isSendSms) return;
      if (!this.username) {
        this.$message.warning({ message: "请输入用户名/证件号码!" ,duration:1000});
        return;
      }
      this.$axios
        .post("/login/forgetPw/" + this.username)
        .then((res) => {
          this.isSendSms = true;
          console.log(res);
          let { code } = res.data;
          this.$message.success({ message: "短信已经发送!" ,duration:1000});
          if (code == 10000) {
            let clock = window.setInterval(() => {
              this.totalTime--;
              if (this.totalTime < 0) {
                window.clearInterval(clock);
                this.totalTime = 60;
                this.isSendSms = false; //这里重新开启
              }
            }, 1000);
          }
        })
        .catch((err) => {
          this.isSendSms = false; //这里重新开启
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.setPassword {
  width: 100vw;
  height: 100vh;
  background-image: url("./../../../assets/img/loginBgImg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .loginLogoBox {
    padding-left: 40px;
    padding-top: 60px;
    img {
      height: 80px;
    }
  }
  .setPassFormBox {
    display: flex;
    justify-content: center; // 水平居中，针对的是mycontainer类下面的子元素，不包含“孙子”元素
    .setPassForm {
      width: 340px;
      padding: 30px;
      margin-top: 6%;
      background-color: white;
      box-shadow: 2px 2px 12px rgba(255, 255, 255, 0.2);
      border-radius: 5px;
      p {
        font-size: 24px;
        font-weight: 700;
        text-align: center;
        margin-bottom: 20px;
      }
      .styleBox {
        margin-bottom: 20px;
      }
    }
  }
}
</style>
